import { OrbitControls } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import React, { useRef } from 'react';
import { useLoader } from 'react-three-fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import yash from '../assets/models/update.glb';

function Model() {
  const gltf = useLoader(GLTFLoader, yash);
  const modelRef = useRef();
  const orbitControlsRef = useRef();

  useFrame(() => {
    orbitControlsRef.current && orbitControlsRef.current.update();
  });

  return (
    <>
      <OrbitControls ref={orbitControlsRef} />
      <group ref={modelRef}>
        <primitive object={gltf.scene} />
      </group>
    </>
  );
}

export default Model;
